import features_1 from "../assets/images/features_1.png";
import features_2 from "../assets/images/features_2.png";
import features_3 from "../assets/images/features_3.png";
import features_4 from "../assets/images/features_4.png";

import overview_1 from "../assets/overview/overview_1.png";
import overview_2 from "../assets/overview/overview_2.png";
import overview_3 from "../assets/overview/overview_3.png";
import overview_4 from "../assets/overview/overview_4.png";
import overview_5 from "../assets/overview/overview_5.png";
import overview_6 from "../assets/overview/overview_6.png";
import overview_7 from "../assets/overview/overview_7.png";
import overview_8 from "../assets/overview/overview_8.png";
import overview_9 from "../assets/overview/overview_9.png";
import model_construction from "../assets/overview/model_construction.png";
import model_selection from "../assets/overview/model_selection.png";
import model_slicing from "../assets/overview/model_slicing.png";
import unified_testing from "../assets/overview/unified_testing.png";

export const HOME_FEATURE_IMAGES = [
  features_1,
  features_2,
  features_3,
  features_4,
];

export const HOME_OVERVIEW_ASSETS = [
  {
    image: overview_1,
    path: "",
    children: [
      { image: model_selection, path: "" },
      { image: model_slicing, path: "" },
      { image: model_construction, path: "" },
    ],
  },
  {
    image: overview_2,
    path: "projects/neurbench",
    children: [{ image: unified_testing, path: "" }],
  },
  {
    image: overview_3,
    path: "",
  },
  {
    image: overview_4,
    path: "projects/neurbench",
  },
  {
    image: overview_5,
    path: "projects/neurcc",
  },
  {
    image: overview_6,
    path: "projects/neurindex",
  },
  {
    image: overview_7,
    path: "",
  },
  {
    image: overview_8,
    path: "projects/neurstore",
  },
  {
    image: overview_9,
    path: "",
  },
];
